import React, { Component } from 'react';

//componentes
import ReciboI from './reciboI'

class Index extends Component {

    render(){
        return(
            <div>
                <ReciboI />
            </div>
        );
    }

}
export default Index;